import { strictFetch, unstrictFetch } from "./http";
import { isAuthErrorMessage } from "@/utils/authSession";

function isAuthRejectionError(e) {
  const msg = e && (e.message || String(e));
  return (
    isAuthErrorMessage(msg) ||
    (typeof msg === "string" && msg.includes("重新登录"))
  );
}

// 封装处理异常的通用业务get请求方法
export async function getAction(url, parameter) {
  let responseData = { code: -9999, message: url + "接口异常！" };
  try {
    responseData = await strictFetch({ url: url, method: "GET", params: parameter });
  } catch (e) {
    if (isAuthRejectionError(e)) {
      return { code: 401, msg: e.message || "请重新登录" };
    }
  }
  return responseData;
}

// 统一处理post请求
export async function postAction(url, parameter) {
  let responseData = { code: -9999, message: url + "接口异常！" };
  try {
    responseData = await strictFetch({ url: url, method: "POST", data: parameter });
  } catch (e) {
    if (isAuthRejectionError(e)) {
      return { code: 401, msg: e.message || "请重新登录" };
    }
  }
  return responseData;
}

// 得到数据字典通用api
export async function getDataDict(url, parameter) {
  const { success, result } = await getAction(url, parameter);
  if (success) {
    return result || [];
  }
  return [];
}
